import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation(
    $data: OperatorCreateInput!
  ) {
    createOneOperator(data: $data) {
      name
    }
  }
`

export default () => (
  useMutation(MUTATION, `Operador criado`, mutationTypes.CREATE)
)
